var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOnDemand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69725 7.96939H10.3028C11.0894 7.96939 11.5 7.56706 11.5 6.75802V1.71137C11.5 0.902332 11.0894 0.5 10.3028 0.5H1.69725C0.910609 0.5 0.5 0.902332 0.5 1.71137V6.75802C0.5 7.56706 0.910609 7.96939 1.69725 7.96939ZM4.91297 6.30321C4.68821 6.30321 4.50668 6.13265 4.50668 5.82216V2.64286C4.50668 2.33236 4.68821 2.16618 4.91297 2.16618C5.02534 2.16618 5.12043 2.20117 5.22849 2.25802L7.83477 3.8105C8.02927 3.92857 8.12436 4.05977 8.12436 4.23032C8.12436 4.40525 8.02495 4.54082 7.83477 4.65452L5.22849 6.207C5.12043 6.26822 5.02534 6.30321 4.91297 6.30321ZM3.78919 9.5H8.21081C8.42692 9.5 8.60413 9.3207 8.60413 9.10204C8.60413 8.88338 8.42692 8.69971 8.21081 8.69971H3.78919C3.57308 8.69971 3.39587 8.88338 3.39587 9.10204C3.39587 9.3207 3.57308 9.5 3.78919 9.5Z",
    fill: "#09090A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnDemand);
export default __webpack_public_path__ + "static/media/icon-on-demand.4b83ba648cd31dc83725414a8d98ee2d.svg";
export { ForwardRef as ReactComponent };